module.exports = __webpack_public_path__ + "static/media/location.dea1e4d3.png";